/**
 * Wer angemeldet ist — und im Demonstrationsstand: als wer man sehen möchte.
 *
 * **Der Umschalter steht sichtbar in der Kopfzeile, nicht in einem
 * Entwicklermenü.** Das ist der Punkt: Eine angenommene Rolle ist unsichtbar
 * und deshalb gefährlich — man vergisst, dass sie gesetzt ist, und hält die
 * Sicht für die Sicht aller. Eine gewählte Rolle steht im Bild und wird
 * mitgelesen.
 *
 * Was der Wechsel tatsächlich ändert, ist absichtlich wenig: die sichtbaren
 * Navigationspunkte (`navigation.ts`) und die Vorbelegung der Listen. Er
 * **prüft nichts**. Nach `01` §1.11 entscheidet die Berechtigung das
 * Quellsystem, und ein Portal, das hier eine zweite Prüfung vortäuscht, baut
 * genau die Sicherheit, die man später für echt hält.
 */

import { useSitzung } from "./Sitzung.js";

/** Die Rolle in einem Wort, für die Zeile im Kopf. */
const ROLLENTEXT: Record<string, string> = {
  "tenant-admin": "Inhaber",
  office: "Büro",
  dispatcher: "Disposition",
  technician: "Monteur",
  accounting: "Buchhaltung",
  "external-guest": "Gast",
  "external-partner": "Externer Partner",
};

function beschriftung(rollen: readonly string[]): string {
  // Die erste Rolle beschreibt die Person am besten: Die Liste in
  // `stammdaten.ts` beginnt bei jedem mit der tragenden Rolle. Alle
  // aufzuzählen ergäbe „Inhaber, Büro, Disposition" und damit eine Kopfzeile,
  // die breiter ist als die Navigation.
  const erste = rollen[0];
  return erste ? (ROLLENTEXT[erste] ?? erste) : "ohne Rolle";
}

export function Personenwahl() {
  const { bestand, person, wechsleZu } = useSitzung();

  return (
    <label className="shell__person">
      Angemeldet als
      <select
        value={person.ref.opaqueId}
        onChange={(e) => {
          const neu = bestand.personen.find((p) => p.ref.opaqueId === e.target.value);
          if (neu) wechsleZu(neu);
        }}
      >
        {bestand.personen.map((p) => (
          <option key={p.ref.opaqueId} value={p.ref.opaqueId}>
            {p.name} — {beschriftung(p.rollen)}
          </option>
        ))}
      </select>
    </label>
  );
}
